import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const ORDER = ["L", "M", "S", "D"];

export default function SeriesGrid({ services = [] }) {
  const byCode = Object.fromEntries(services.map((s) => [s.series_code, s]));

  return (
    <div data-testid="services-hero-grid" className="grid grid-cols-2 gap-px border border-obsidian/20 bg-obsidian/20">
      {ORDER.map((code, i) => {
        const s = byCode[code];
        const inner = (
          <>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slategray transition-colors duration-300 group-hover:text-paper/70">
              {code} Series
            </span>
            <span className="font-serif text-7xl font-medium leading-none tracking-tight text-progress transition-transform duration-500 ease-out group-hover:-translate-y-1 md:text-8xl">
              {code}
            </span>
            <span className="text-sm font-medium leading-snug text-obsidian/80 transition-colors duration-300 group-hover:text-paper">
              {s?.title?.replace(/ Program$/, "") || ""}
            </span>
          </>
        );
        const cls =
          "group flex aspect-square flex-col justify-between bg-paper p-6 transition-colors duration-500 hover:bg-obsidian md:p-8";
        return (
          <motion.div
            key={code}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35 + i * 0.12, ease: EASE }}
            className="flex min-w-0"
          >
            {s ? (
              <Link to={`/services/${s.slug}`} data-testid={`series-tile-${code}`} className={`${cls} w-full`}>
                {inner}
              </Link>
            ) : (
              <div className={`${cls} w-full`}>{inner}</div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
